import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, renderList as _renderList, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49023c5d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = { class: "inner1" }
const _hoisted_7 = { class: "title_left" }
const _hoisted_8 = {
  key: 0,
  class: "error-message",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"24%"} })
  ])
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode(" 表示期間 ")
], -1))
const _hoisted_11 = ["max"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin":"0rem 0.2rem"} }, "～", -1))
const _hoisted_13 = ["max"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode(" タイトル ")
], -1))
const _hoisted_15 = { class: "form-inline flex-container" }
const _hoisted_16 = {
  class: "form-group",
  style: {"width":"35%","margin-right":"1rem"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "表示対象", -1))
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = ["value"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "rdoAll",
  class: "form-check-label"
}, "全員", -1))
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = ["value"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "rdoAgSegment",
  class: "form-check-label"
}, " エージェントセグメント ", -1))
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = ["value"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "rdoAg",
  class: "form-check-label"
}, " 個別エージェント ", -1))
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "AGコード", -1))
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { class: "file-upload" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["accept", "disabled"]
const _hoisted_38 = {
  class: "form-group",
  style: {"width":"65%","min-height":"210px"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "本文", -1))
const _hoisted_41 = { class: "form-inline flex-container" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"20%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"3%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"25%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"14%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"3%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"45%"} })
  ])
], -1))
const _hoisted_43 = {
  key: 0,
  class: "form-control-title"
}
const _hoisted_44 = { key: 1 }
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = {
  key: 2,
  class: "form-control-title"
}
const _hoisted_47 = { key: 3 }
const _hoisted_48 = ["onUpdate:modelValue"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"20%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"3%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"27%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"40%"} })
  ])
], -1))
const _hoisted_50 = { colspan: "4" }
const _hoisted_51 = { class: "file-upload" }
const _hoisted_52 = ["accept"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "添付ファイル説明", -1))
const _hoisted_55 = { colspan: "5" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { colspan: "4" }
const _hoisted_58 = { class: "file-upload" }
const _hoisted_59 = ["accept"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "画像ファイル説明", -1))
const _hoisted_62 = { colspan: "4" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = {
  class: "form-group",
  style: {"width":"40%","margin-left":"1rem"}
}
const _hoisted_65 = { style: {"height":"96%","padding":"1rem"} }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "チェックパターン", -1))
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = ["value"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "checklabel" }, "次回以降表示しない", -1))
const _hoisted_70 = ["value"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "checklabel" }, "確認した", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "ポップアップ表示対象", -1))
const _hoisted_73 = { class: "form-group" }
const _hoisted_74 = ["value"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "checklabel" }, "全員", -1))
const _hoisted_76 = ["value"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "checklabel" }, "管理者のみの表示可能", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"40%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} })
], -1))
const _hoisted_79 = {
  colspan: "3",
  style: {"text-align":"right","margin-top":"1rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, [
                (_ctx.isEditModeUpdate)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.contentsCategoryName) + "更新 ", 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.contentsCategoryName) + "登録", 1)
                    ], 64))
              ]),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("table", null, [
                _hoisted_9,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_10,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        id: "txtDispDtFrom",
                        class: "form-control",
                        ref: "txtDispDtFrom",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.PopupData.keisaiKikanStart) = $event)),
                        max: _ctx.AppConstants.MAX_DATE_VALUE
                      }, null, 8, _hoisted_11), [
                        [_vModelText, _ctx.PopupData.keisaiKikanStart]
                      ]),
                      _hoisted_12,
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        id: "txtDispDtFrom",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.PopupData.keisaiKikanEnd) = $event)),
                        max: _ctx.AppConstants.MAX_DATE_VALUE
                      }, null, 8, _hoisted_13), [
                        [_vModelText, _ctx.PopupData.keisaiKikanEnd]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_14,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "txtTitle",
                        maxlength: "255",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.PopupData.title) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.PopupData.title]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("fieldset", null, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "rdoAll",
                        name: "hyojiTaisho",
                        value: _ctx.LoginPopupRegConstants.HYOJI_TAISHO_ALL,
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.PopupData.hyojiTaisho) = $event)),
                        onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onChangeHyojiTaisho && _ctx.onChangeHyojiTaisho(...args)))
                      }, null, 40, _hoisted_19), [
                        [_vModelRadio, _ctx.PopupData.hyojiTaisho]
                      ]),
                      _hoisted_20
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "rdoAgSegment",
                        name: "hyojiTaisho",
                        value: _ctx.LoginPopupRegConstants.HYOJI_TAISHO_AG_SEGMENT,
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.PopupData.hyojiTaisho) = $event)),
                        onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onChangeHyojiTaisho && _ctx.onChangeHyojiTaisho(...args)))
                      }, null, 40, _hoisted_22), [
                        [_vModelRadio, _ctx.PopupData.hyojiTaisho]
                      ]),
                      _hoisted_23
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("select", {
                        id: "cmbAgSegment",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.PopupData.agSegmentId) = $event)),
                        disabled: !_ctx.isHyojiTaishoAgSegment
                      }, [
                        _hoisted_26,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agSegmentList, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.agSegmentCode,
                            value: item.agSegmentCode
                          }, _toDisplayString(item.agSegmentCode) + "：" + _toDisplayString(item.agSegmentName), 9, _hoisted_27))
                        }), 128))
                      ], 8, _hoisted_25), [
                        [_vModelSelect, _ctx.PopupData.agSegmentId]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "rdoAg",
                        name: "hyojiTaisho",
                        value: _ctx.LoginPopupRegConstants.HYOJI_TAISHO_AG_CODE,
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.PopupData.hyojiTaisho) = $event)),
                        onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onChangeHyojiTaisho && _ctx.onChangeHyojiTaisho(...args)))
                      }, null, 40, _hoisted_29), [
                        [_vModelRadio, _ctx.PopupData.hyojiTaisho]
                      ]),
                      _hoisted_30
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "txtAgCode",
                        maxlength: "8",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.PopupData.agCode) = $event)),
                        disabled: 
                    !_ctx.isHyojiTaishoAgCode || _ctx.PopupData.agCodeList.length > 0
                  
                      }, null, 8, _hoisted_33), [
                        [_vModelText, _ctx.PopupData.agCode]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("button", {
                          class: _normalizeClass([
                      'btn',
                      'btn-sm',
                      _ctx.isHyojiTaishoAgCode ? 'btn-primary' : 'btn-secondary',
                    ]),
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onAgCodeFileUpload && _ctx.onAgCodeFileUpload(...args))),
                          disabled: !_ctx.isHyojiTaishoAgCode
                        }, " アップロード ", 10, _hoisted_36),
                        _createElementVNode("input", {
                          type: "file",
                          accept: _ctx.hyojiTaishoExtensions.join(','),
                          onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleAgCodeFileUpload && _ctx.handleAgCodeFileUpload(...args))),
                          disabled: !_ctx.isHyojiTaishoAgCode,
                          ref: "agCodeFileInput",
                          style: {"display":"none"}
                        }, null, 40, _hoisted_37)
                      ]),
                      _withDirectives(_createElementVNode("label", { style: {"margin-left":"1rem"} }, _toDisplayString(_ctx.getValueAgCodeUploadCnt), 513), [
                        [_vShow, _ctx.PopupData.agCodeList.length > 0]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _hoisted_40,
                  _createVNode(_component_QuillEditor, {
                    id: "rtxtHonbun",
                    "onUpdate:content": _ctx.handleContentUpdate,
                    modelValue: _ctx.PopupData.contentsBody,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.PopupData.contentsBody) = $event)),
                    style: {"height":"210px"}
                  }, null, 8, ["onUpdate:content", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", null, [
                  _createElementVNode("table", null, [
                    _hoisted_42,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PopupData.contentsLinkList, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.rowNo
                        }, [
                          (index == 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_43, " リンクキャプション "))
                            : (_openBlock(), _createElementBlock("td", _hoisted_44)),
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "255",
                              class: "form-control",
                              "onUpdate:modelValue": ($event: any) => ((item.caption) = $event)
                            }, null, 8, _hoisted_45), [
                              [_vModelText, item.caption]
                            ])
                          ]),
                          (index == 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_46, " リンクURL "))
                            : (_openBlock(), _createElementBlock("td", _hoisted_47)),
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "255",
                              class: "form-control",
                              "onUpdate:modelValue": ($event: any) => ((item.url) = $event)
                            }, null, 8, _hoisted_48), [
                              [_vModelText, item.url]
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("table", null, [
                    _hoisted_49,
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          class: _normalizeClass([
                      'form-control-title',
                      { 'vertical-align-top': _ctx.hasContentsTempFile },
                    ])
                        }, " 添付ファイル ", 2),
                        _createElementVNode("td", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("button", {
                              class: "btn btn-primary btn-sm",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (
                          _ctx.onContentsFileUpload(
                            _ctx.LoginPopupRegConstants.TRIGGER_TEMP_FILE
                          )
                        ))
                            }, " + "),
                            _createElementVNode("input", {
                              type: "file",
                              accept: _ctx.tempFileExtensions.join(','),
                              onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleContentsFileSelected && _ctx.handleContentsFileSelected(...args))),
                              ref: "tempFileInput",
                              style: {"display":"none"}
                            }, null, 40, _hoisted_52)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PopupData.contentsTempFileList, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.rowNo
                            }, [
                              _createElementVNode("button", {
                                class: "btn btn-danger btn-sm",
                                onClick: ($event: any) => (
                          _ctx.onRemoveContentsFile(
                            item.rowNo,
                            _ctx.LoginPopupRegConstants.TRIGGER_TEMP_FILE
                          )
                        )
                              }, " - ", 8, _hoisted_53),
                              _createTextVNode(" " + _toDisplayString(item.fileName), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_54,
                        _createElementVNode("td", _hoisted_55, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            maxlength: "255",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.PopupData.contentsTempFileExp) = $event)),
                            disabled: !_ctx.hasContentsTempFile
                          }, null, 8, _hoisted_56), [
                            [_vModelText, _ctx.PopupData.contentsTempFileExp]
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          class: _normalizeClass([
                      'form-control-title',
                      { 'vertical-align-top': _ctx.hasContentsImgFile },
                    ])
                        }, " 画像ファイル ", 2),
                        _createElementVNode("td", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("button", {
                              class: "btn btn-primary btn-sm",
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (
                          _ctx.onContentsFileUpload(
                            _ctx.LoginPopupRegConstants.TRIGGER_IMG_FILE
                          )
                        ))
                            }, " + "),
                            _createElementVNode("input", {
                              type: "file",
                              accept: _ctx.imgFileExtensions.join(','),
                              onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.handleContentsFileSelected && _ctx.handleContentsFileSelected(...args))),
                              ref: "imgFileInput",
                              style: {"display":"none"}
                            }, null, 40, _hoisted_59)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PopupData.contentsImgList, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.rowNo
                            }, [
                              _createElementVNode("button", {
                                class: "btn btn-danger btn-sm",
                                onClick: ($event: any) => (
                          _ctx.onRemoveContentsFile(
                            item.rowNo,
                            _ctx.LoginPopupRegConstants.TRIGGER_IMG_FILE
                          )
                        )
                              }, " - ", 8, _hoisted_60),
                              _createTextVNode(" " + _toDisplayString(item.fileName), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_61,
                        _createElementVNode("td", _hoisted_62, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            maxlength: "255",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.PopupData.contentsImgFileExp) = $event)),
                            disabled: !_ctx.hasContentsImgFile
                          }, null, 8, _hoisted_63), [
                            [_vModelText, _ctx.PopupData.contentsImgFileExp]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("fieldset", _hoisted_65, [
                    _hoisted_66,
                    _createElementVNode("div", _hoisted_67, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "rdoAll",
                        name: "checkPatarn",
                        value: _ctx.LoginPopupRegConstants.CHECK_PATARN_JIKAI,
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.PopupData.checkPatern) = $event))
                      }, null, 8, _hoisted_68), [
                        [_vModelRadio, _ctx.PopupData.checkPatern]
                      ]),
                      _hoisted_69,
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "rdoAll",
                        name: "checkPatarn",
                        value: _ctx.LoginPopupRegConstants.CHECK_PATARN_KAKUNIN,
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.PopupData.checkPatern) = $event))
                      }, null, 8, _hoisted_70), [
                        [_vModelRadio, _ctx.PopupData.checkPatern]
                      ]),
                      _hoisted_71
                    ]),
                    _hoisted_72,
                    _createElementVNode("div", _hoisted_73, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "rdoAll",
                        name: "checkDsipTarget",
                        value: _ctx.LoginPopupRegConstants.CHECK_DISP_TARGET_ALL,
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.PopupData.checkDispTarget) = $event))
                      }, null, 8, _hoisted_74), [
                        [_vModelRadio, _ctx.PopupData.checkDispTarget]
                      ]),
                      _hoisted_75,
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "rdoAll",
                        name: "checkDsipTarget",
                        value: _ctx.LoginPopupRegConstants.CHECK_DISP_TARGET_KANNRI,
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.PopupData.checkDispTarget) = $event))
                      }, null, 8, _hoisted_76), [
                        [_vModelRadio, _ctx.PopupData.checkDispTarget]
                      ]),
                      _hoisted_77
                    ])
                  ])
                ])
              ]),
              _createElementVNode("table", null, [
                _hoisted_78,
                _createElementVNode("tbody", null, [
                  _createElementVNode("td", _hoisted_79, [
                    _createElementVNode("button", {
                      type: "button",
                      name: "btnBack",
                      class: "btn btn-footer btn-primary",
                      onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
                    }, " 戻る ")
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      type: "button",
                      name: "btnFixed",
                      class: "btn btn-footer btn-primary",
                      onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.onFixed && _ctx.onFixed(...args)))
                    }, [
                      (_ctx.isEditModeUpdate)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("更新")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("登録")
                          ], 64))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}